import * as z from "zod";

export const getUcpManifest = {
  name: "getUcpManifest" as const,
  input: z.null(),
  output: z.object({ manifest: z.string() }),
};
